import AscButton from "../../AscButton/AscButton";
import AscModal from "../../AscModal/AscModal";
import styles from "./AscProjectCard.module.scss";

interface IDeleteProjectModalProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
  deleteProject: () => void;
}

export const DeleteProjectModal = ({
  visible,
  setVisible,
  deleteProject,
}: IDeleteProjectModalProps) => (
  <AscModal
    visible={visible}
    setVisible={setVisible}
    hasCloseBtn={false}
    modalClassName={styles.deleteModal}
  >
    <div className={styles.deleteText}>
      Are you sure you want to delete this project?
    </div>
    <div className={styles.deleteButtons}>
      <AscButton
        type="button"
        variant="secondary"
        onClick={() => setVisible(false)}
      >
        Cancel
      </AscButton>
      <AscButton type="button" variant="red" onClick={deleteProject}>
        Confirm
      </AscButton>
    </div>
  </AscModal>
);
